<template>
  <div :class="{'fshr-simpleMap':true, 'fshr-mapLoading': loading_map}" :style="heightOfMap">
    <ul class="fshr-map-legend" v-if="show_legend">
      <li v-for="legend in show_legend" class="fshr-map-legend-item fshr-icon fshr-icon--pinModified" :class="[legend.className]">{{legend.label}}</li>
    </ul>
    <l-map
      ref="map"
      :options="mapOptions"
      :maxZoom="layerOptions.maxZoom"
      :bounds="bounds"
      :center="mapCenter"
      @ready="loading_map = false"
    >
      <l-control-fullscreen position="topright" />
      <v-marker-cluster
              :options="clusterOptions"
      >
        <l-marker v-for="pin in pins" :lat-lng="pin.position" :icon="getIcon(pin)">
          <l-popup v-if="pin.hasOwnProperty('content') && show_tooltip">
            <HotelMarkerDetails :content="pin.content" :url="pin.url"/>
          </l-popup>
        </l-marker>
      </v-marker-cluster>
      <l-tile-layer :options="layerOptions" :tile-layer-class="tileLayerClass">
      </l-tile-layer>
    </l-map>
  </div>
</template>

<script>
import mapMixin from "../mixins/mapMixin";

import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import LControlFullscreen from "vue2-leaflet-fullscreen";
import mapboxgl from "maplibre-gl";
import "leaflet/dist/leaflet.css";
import "maplibre-gl/dist/maplibre-gl.css";
import "mapbox-gl-leaflet";
import "../vendor/leaflet-maplibre";
import HotelMarkerDetails from "./HotelMarkerDetails.vue";
import LoadingSkeleton from "./common/LoadingSkeleton.vue";
window.mapboxgl = mapboxgl;

export default {
  components: {
    LPopup,
    LMap,
    LMarker,
    LTileLayer,
    HotelMarkerDetails,
    LControlFullscreen,
    "v-marker-cluster": Vue2LeafletMarkercluster,
    LoadingSkeleton,
  },
  name: "SimpleMap",
  mixins: [mapMixin],
  data: function () {
    return {
      loading_map: true,
      tileLayerClass: (url, options) => L.mapboxGL(options),
    };
  },
  mounted: function () {
    if(Object.prototype.hasOwnProperty.call(window, "map")){
      window.map.push(this);
    }else{
      window["map"] = [this];
    }
  },
  computed: {
    heightOfMap: function (){
      if(this.height !== false){
        return {height: this.height + 'px'}
      }
      return {};
    },
  },
  methods: {
    fitBounds(){
      var map_object = this.$refs.map.mapObject;
      setTimeout(()=>{
        map_object.fitBounds(this.bounds);
      },100);
    },
  },
  props: {
    pins: {
      type: Array,
      default: function () {
        return [
          {
            id: "k8319",
            position: {
              lat: 46.989635,
              lng: 13.169720
            },
            content: {
              imageSrc: "/Data/Kapacity/8319/01_RA_Molltal_Alber_ext1_n_219x0.jpg",
              imageSmallSrc: "/Data/Kapacity/8319/01_RA_Molltal_Alber_ext1_n_219x0.jpg",
              title: "Ferienhotel Alber - zkrácené pobyty",
              stars: "****",
              locations: [
                { "title": "Rakousko" },
                { "title": "Korutany" },
                { "title": "Mölltal - Ankogel" }
              ],
              priceText: {
                label: 'dospělý',
                price: 'od 2 498 Kč'
              },
              pictograms: [
                { "icon": "fshr-icon--cabinDistanceNew", "title": "Vzdálenost od lanovky 3,5 km" },
                { "icon": "fshr-icon--wellnessNew", "title": "Kvalita wellness **" },
                { "icon": "fshr-icon--forkSpoonNew", "title": "Rozšířená polopenze HB+" },
                { "icon": "fshr-icon--dogNew", "title": "Možnost ubytování se psem – Info" },
                { "icon": "fshr-icon--kid", "title": "Dítě zdarma" },
                { "icon": "fshr-icon--wifi", "title": "Připojení k internetu – ZDARMA" }
              ]
            },
            url: "/zima/rakousko/molltal-ankogel/ferienhotel-alber-zkracene-pobyty"
          }
        ];
      },
      required: false,
    },
    fullscreen: {
      required: false,
      default: false,
      type: Boolean
    },
    height: {
      required: false,
      default: false,
      type: Number | Boolean
    },
    show_tooltip: {
      required: false,
      default: true,
      type: Boolean
    },
    show_legend: {
      required: false,
      default: function (){
        return [
          {label: "hotelové", className: "fshr-map-legend-item--hotel"},
          {label: "apartmánové", className: "fshr-map-legend-item--apartment"},
        ]
      },
      type: Boolean | Array
    }
  }
};
</script>

<style lang="less">
.fshr-simpleMap {
  min-height: 230px;
  width: 100%;
  height: 100%;

  .vue2leaflet-map {
    z-index: 1;
  }
}
@import "../less/variables.less";
@import "../../../../../Content/css/components/component-search-result-map.less";

</style>
